import AddCategoryForm from "../../Form/AddCategoryForm";
import AddSubCategoryForm from "../../Form/AddSubCategoryForm";
import AddTeamMemberForm from "../../Form/AddTeamMemberForm";
import AddTestimonialForm from "../../Form/AddTestimonialForm";

const ModalAddTestimonial = ({ isVisible, onClose }) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-2xl shadow-2xl w-[65%] mx-4 sm:mx-auto  overflow-hidden">
        {/* Header */}
        <div className="flex justify-between py-4 px-6 items-center border-b bg-blue-600 rounded-t-2xl shadow-md">
          <h1 className="text-white text-xl font-semibold">Add Testimonial</h1>
          <button
            onClick={onClose}
            aria-label="Close modal"
            className="w-9 h-9 rounded-full flex justify-center items-center transition hover:bg-blue-700"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-7 w-7 text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Content */}
        <div className="bg-gray-50 p-6 ">
          <AddTestimonialForm onClose={onClose}></AddTestimonialForm>
        </div>

        {/* Footer (Optional) */}
        <div className="flex justify-end p-4 border-t bg-gray-100 rounded-b-2xl"></div>
      </div>
    </div>
  );
};

export default ModalAddTestimonial;
